import { ReactComponent as DataElementTopRightSquare } from '@/assets/svgs/arrow-top-right-on-square.svg';
import { ReactComponent as IconInputEdit } from '@/assets/svgs/edit-input-reference.svg';
import iconBuilding from '@/assets/svgs/icon-building.svg';
import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg';
import { ReactComponent as DataElementIconInComplete } from '@/assets/svgs/icon-data-element-incomplete.svg';
import { ReactComponent as DataElementIconSuccess } from '@/assets/svgs/icon-data-element-success.svg';
import { ReactComponent as DataElementIcon } from '@/assets/svgs/icon-data-element.svg';
import { ReactComponent as IconTrashBin } from '@/assets/svgs/icon-trash-bin.svg';
import { ReactComponent as InformationCircle } from '@/assets/svgs/information-circle.svg';
import Button from '@/components/Button';
import CustomDropdown from '@/components/CustomDropdown/index.js';
import Input from '@/components/Input';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import PaginateAttachments from '@/components/PaginateAttachments/index';
import SplitFileType from '@/components/SplitFileType/index';
import currentStatuses from "@/constants/statuses/index";
import useModal from '@/hooks/use-modal/index';
import rem from '@/utils/rem';
import classname from 'classnames';
import { useRef, useState } from "react";
import MultiClamp from 'react-multi-clamp';
import MultiLevelDropDown from '../MultiLevelMenuDropDown/index';

export function OrganisationAvatar(organisation){
	if((Array.isArray(organisation) && organisation.length === 1) && ((organisation[0]?.iconUrl !== "") && (organisation[0]?.iconUrl !== "undefined"))){
		return organisation[0]?.iconUrl
	}

	return iconBuilding
}

const DataElementCard = ({
		status = currentStatuses.not_started,
		recipient,
		referenceId,
		dataElement,
		storeFor,
		payload,
		action,
		onBehalfOf,
		onBehalfOfList,
		requiredAttachments,
		attachments,
		behalfPanel,
		participantsList,
		storeForList,
		combineAttachments,
		getRootPropsPayload,
		getInputPropsPayload,
		getRootPropsAttachment,
		getInputPropsAttachment,
		containAttachments,
		matchingAttachments,
		nonMatchingAttachments,
		handleRemoveSingleFile,
		handleDownloadSingleFile,
		onFillEformBtnClick,
		handleReferenceID,
		handleRemoveFile,
		handleRecipientChange,
		handleStoreForChange,
		handleOnBehalfOfChange,
		isPackage = false,
		packageDropdownMenu,
}) => {

	const [attachmentModal, setAttachmentModal] = useState(false)
	const [activeReferenceID, setActiveReferenceID] = useState(false)

	/*=================================================
		Reference ID
	/================================================*/
	const referenceIdRef = useRef(null)

	/*=================================================
		Custom Classnames
	/================================================*/
	const structuredDataClassName = classname({
		"share-data-card__section": true,
		"share-data-card__section--disabled": recipient?.length === 0 || (isPackage && behalfPanel && onBehalfOf?.length === 0)
	})

	const attachmentDataClassName = classname({
		"share-data-card__section": true,
		"share-data-card__section--disabled": (payload?.length === 0 || containAttachments === false) && action?.type !== "IMPORTED"
	})

	/*=================================================
		Attachment Dropzone
	/================================================*/

	function renderUplaodAttachment() {
		return (
			<div className="share-data-card__upload-attachment" {...getRootPropsAttachment()}>
				<input
					{...getInputPropsAttachment()}
					data-testid="attachment-dropzone"
				/>
				Upload Attachment
			</div>
		);
	}

	/*=================================================
		Remove File
	/================================================*/
	const { visible: verifyModal, show: showVerifyModal, hide: hideVerifyModal } = useModal()
	const [file, setFile]= useState()

	const handleVerifyRemove = () => {
		handleRemoveSingleFile(file)
		setFile()
	}

	return (
		<>
			{
				!attachmentModal &&
				<div className="share-data-card">
					{!isPackage && (
						<div className='share-data-card__header'>
							<div className="share-data-card__header__left share-data-card__header__left--icon">
								{status === currentStatuses.not_started && (<DataElementIcon />)}
								{status === currentStatuses.in_progress && (<DataElementIconInComplete />)}
								{status === currentStatuses.complete && (<DataElementIconSuccess />)}
							</div>

							<div className='share-data-card__header__right'>
								<div className='share-data-card__header__top share-data-card__header__top--element'><MultiClamp clamp={2}>{dataElement?.name}</MultiClamp></div>
								{!activeReferenceID && (
									<div className='share-data-card__header__bottom'>
										<div className='share-data-card__header__reference-id'><MultiClamp clamp={1}>{referenceId ? referenceId : 'Reference ID (Optional)'}</MultiClamp></div>
										<IconInputEdit data-testid="edit-reference-id" onClick={()=> setActiveReferenceID(true)}/>
									</div>
								)}
								{activeReferenceID && (
									<div className='share-data-card__header__bottom'>
										<Input
											className='share-data-card__header__reference-input'
											placeholder='Reference ID (Optional)'
											defaultValue={referenceId}
											autoFocus
											register={referenceIdRef}
											maxlength={100}
										/>
									<div
										onClick={() => {
											setActiveReferenceID(false)
											handleReferenceID(referenceIdRef.current.value)
										}}
										className="share-data-card__reference-save">Save</div>
									</div>
								)}
							</div>
						</div>
					)}

					{isPackage && (
						<div className="share-data-card__header--package">
							<div className="share-data-card__header__left">
								{status === currentStatuses.not_started && (<DataElementIcon />)}
								{status === currentStatuses.in_progress && (<DataElementIconInComplete />)}
								{status === currentStatuses.complete && (<DataElementIconSuccess />)}
							</div>
							<div className='share-data-card__header__right--package'>
								<div className='share-data-card__header__top share-data-card__header__top--element'><MultiClamp clamp={2}>{dataElement?.name}</MultiClamp></div>
							</div>
							<div className='share-data-card__header__menu'>
								{dataElement?.isNew && <span className="package-received-data-card__new-tag" data-testid="new-tag">New</span>}
								<MultiLevelDropDown
									menuList={packageDropdownMenu}
								/>
							</div>
						</div>
					)}

					<div className='share-data-card__section'>
						<div className='share-data-card__heading share-data-card__content--margin-bottom'>Participants</div>
						<div className='share-data-card__participants'>
							<div className='share-data-card__participants__icon'>
								<div className="avatar" style={{ backgroundImage: `url(${OrganisationAvatar(recipient)})` }}></div>
							</div>
							<div className='share-data-card__participants__right'>
								<div className='share-data-card__participants-name'>Recipient</div>
								<CustomDropdown
									items={participantsList}
									value={recipient}
									keyText="Recipient"
									type="radio"
									disable={isPackage && participantsList.length <= 1}
									onChangeFunc={(option) => {
										handleRecipientChange(option)
									}}
									dataTestId="recipient-dropdown"
									isPackage={isPackage}
								/>
							</div>
						</div>
						{recipient && recipient[0]?.id === 'MY_PITSTOP' && (
							<div className='share-data-card__participants'>
								<div className='share-data-card__participants__icon'>
									<div className="avatar" style={{ backgroundImage: `url(${OrganisationAvatar(storeFor)})` }}></div>
								</div>
								<div className='share-data-card__participants__right'>
									<div className='share-data-card__participants-org-name tooltip'>
										<span className='share-data-card__participants-name'>Selected Organisations</span>
										<span className="share-data-card__icon"><InformationCircle /></span>
										<span className="tooltiptext">Only Selected Organisations are allowed to consume this data from you</span>
									</div>
									<CustomDropdown
										items={storeForList}
										value={storeFor}
										keyText="Organisations"
										type="checkbox"
										allSelected={false}
										togglecheck={true}
										onChangeFunc={(option) => {
											handleStoreForChange(option)
										}}
										dataTestId="storeFor-dropdown"
									/>
								</div>
							</div>
						)}
						{behalfPanel && (
							<div className='share-data-card__participants'>
								<div className='share-data-card__participants__icon'>
										<div className="avatar" style={{ backgroundImage: `url(${OrganisationAvatar(onBehalfOf)})` }}></div>
									</div>
								<div className='share-data-card__participants__right'>
									<div className='share-data-card__participants-name'>Provide On Behalf Of</div>
										<CustomDropdown
											items={onBehalfOfList}
											value={onBehalfOf}
											disable={onBehalfOfList.length === 1}
											keyText="Contributor"
											type="radio"
											onChangeFunc={(option) => {
												handleOnBehalfOfChange(option)
											}}
											dataTestId="onBehalfOf-dropdown"
											isPackage={isPackage}
										/>
								</div>
							</div>
						)}

					</div>
					<div className={structuredDataClassName}>
						<div className='share-data-card__content--margin-bottom tooltip'>
							<span className="share-data-card__heading">Structured Data</span>
							<span className="share-data-card__icon"><InformationCircle /></span>
							<span className="tooltiptext">{isPackage ? "Fill E-form / Upload .CSV file" : "Fill E-form / Upload .CSV or .JSON file"}</span>
						</div>
						{payload?.length === 0 &&(
							<>
								<div className="share-data-card__structured-section">
									<div className="share-data-card__structured-section__sub-heading"
										data-testid="fill-eform-test"
										onClick={()=>{
											onFillEformBtnClick()
										}}
									>Fill E-Form</div>
									<div className='share-data-card__structured-section__heading-or'>or</div>
									<div className="share-data-card__structured-section__sub-heading"
										{...getRootPropsPayload()}
									>
										<input
											{...getInputPropsPayload()}
											data-testid="payload-dropzone"
										/>
										Upload File
									</div>
								</div>
							</>
						)}
						{payload?.length > 0 && (
							<div className='share-data-card__structured-section_content'>
								{action.type === "EFORM" && (
									<span>
										Filled via E-form
									</span>
								)}
								{action.type === "UPLOAD" && (
									<SplitFileType text={action?.value} maxWidth={216}/>
								)}
								{action.type === "IMPORTED" && (
									<span>
										Imported Data
									</span>
								)}
								<span className='share-data-card__content__icons' data-testid="filled-eform-info">
									{action.type === "EFORM" && <DataElementTopRightSquare
										data-testid="fill-data-element-button"
										onClick={()=> {
											onFillEformBtnClick()
										}}
									/>}
									{action.type !== "IMPORTED" && (
										<IconTrashBin
											data-testid="filled-eform-delete"
											onClick={()=> {
												handleRemoveFile()
											}}
										/>
									)}
								</span>
							</div>
						)}
					</div>
					<div className={attachmentDataClassName}>
						<div className='share-data-card__content--margin-bottom tooltip'>
							<span className="share-data-card__heading">Attachments</span>
							<span className="share-data-card__icon"><InformationCircle /></span>
							<span className="tooltiptext">{isPackage ? "Upload .PDF attachment" : "Upload .PDF or .DOC or .DOCX. OR .TT or .XLSX or .XML or .XLS or .JPG or .JPEG attachment"}</span>
						</div>

						{!isPackage && (matchingAttachments.length > 0 || nonMatchingAttachments.length > 0 || requiredAttachments?.length > 0 ) && (
							<div className="share-data-card__structured-section_content">
								<span>
									{requiredAttachments.length > 0 && (
										<>
											Required {matchingAttachments.length}/{requiredAttachments.length}
										</>
									)}
									{requiredAttachments.length > 0 && nonMatchingAttachments.length > 0 && (
										<>, </>
									)}
									{nonMatchingAttachments.length > 0 && (
										<>Optional {nonMatchingAttachments.length}</>
									)}
								</span>
								<span className='share-data-card__content__icons' data-testid='attachment-delete'>
									<DataElementTopRightSquare
										data-testid="data-element-card-view"
										onClick={()=> {
											setAttachmentModal(true)
										}}
									/>
								</span>
							</div>
						)}

						{(isPackage && combineAttachments.length > 0) && (
							<div className="share-data-card__structured-section_content">
								<span>
									<>Uploaded Attachment &#40;{combineAttachments.length}&#41;</>
								</span>
								<span className='share-data-card__content__icons'>
									<DataElementTopRightSquare
										data-testid="data-element-card-view"
										onClick={()=> {
											setAttachmentModal(true)
										}}
									/>
								</span>
							</div>
						)}

						{(isPackage && combineAttachments.length === 0 && action.type === "IMPORTED") && (
							<div className="share-data-card__structured-section_content">
								<span>
									No attachment
								</span>

							</div>
						)}

						{containAttachments && action.type !== "IMPORTED" && (
							<>{renderUplaodAttachment()}</>
						)}
					</div>
				</div>
			}
			{
				attachmentModal &&
				<div className="share-data-card share-data-card--flex">
					<div className="share-data-card__upload__header">
						<MultiClamp clamp={1} className="share-data-card__upload__header__title">{dataElement?.name}</MultiClamp>
					</div>
					<div className="share-data-card__upload__sub-header">
						Attachments({matchingAttachments.length + nonMatchingAttachments.length})
					</div>
					<div className="share-data-card__upload__content">
						<PaginateAttachments
							combineAttachments={combineAttachments}
							attachments={attachments}
							requiredAttachments={requiredAttachments}
							handleDownloadSingleFile={handleDownloadSingleFile}
							showVerifyModal={showVerifyModal}
							setFile={setFile}
							showDelete={action.type === "IMPORTED" ? false : true}
						/>
					</div>
					{action.type !== "IMPORTED" &&(
						<div className="share-data-card__upload__upload">
							{renderUplaodAttachment()}
						</div>
					)}
					<div className="share-data-card__upload__footer">
						<span className="share-data-card__upload-attachment" onClick={()=>{setAttachmentModal(false)}}>
							Back
						</span>
					</div>
				</div>
			}

			<Modal visible={verifyModal} variant='medium'  close={hideVerifyModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon--error'}>
											<IconTrashBin />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Delete Data
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className='share__card-configure-text'>Are you sure want to delete the uploaded Attachment(s)?</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button ghost text="Cancel"
								submit={() => {
									hideVerifyModal()
								}}
							/>
							<span style={{ width: rem(10), display: 'inline-block' }}></span>
							<Button ghost
								text="Confirm"
								warning
								submit={() => {
									handleVerifyRemove()
									hideVerifyModal()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>
	)
}


export default DataElementCard;
